import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';

@Component({
    selector: 'hsn-template',
    template: require('./hsnTemplate.html'),
    styles: [``]
})
export class HsnTemplateComponent implements OnInit {

    @Input('hsnList') hsnList: any;
    @Input("cValue") cValue: any;
    @Input("dValue") dvalue: any;
    @Output() SelectedHsn = new EventEmitter();
    static parameters = [UtilityService]
    constructor(public utilityService: UtilityService) { }
    gridApiHsn: any;
    gridColumnApiHsn: any;
    paginationConf: any;
    hsncodeList: any;
    glDef1: any;
    selectedHsnInfo: any;
    defaultColDef: any;
    d: any;
    rowSelectionSingle: string;
    searchValue: any;

    ngOnInit(): void {
        //   console.log('hsn template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    onGridReadyHsn(params) {
        this.glDef1 = [
            { headerName: 'HSN Code', field: 'HSN_Code', width: 110 },
            { headerName: 'HSN Desc', field: 'HSN_Desc', width: 260 },
            { headerName: 'SGST %', field: 'HSN_sgst', width: 110 },
            { headerName: 'CGST %', field: 'HSN_cgst', width: 110 },
            { headerName: 'IGST %', field: 'HSN_igst', width: 110 },
            { headerName: 'Version', field: 'HSN_Version', width: 100 }

        ];

        this.hsncodeList = this.hsnList;
        //   console.log('hsnList', this.hsncodeList);
        //   console.log("param on ready:", params);
        this.gridApiHsn = params.api;
        this.gridColumnApiHsn = params.columnApi;

        setTimeout(() => {
            this.gridApiHsn.sizeColumnsToFit();

            //   console.log(this.selectedHsnInfo);
        }, 1);
        //   this.gridColumnApiCust.autoSizeColumns(allColumnIds);

        this.defaultColDef = {
            resizable: true,
        };
    }

    gridEventDown(event) {
        if (event.keyCode == 13) {
            this.hsnSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#filter-text-box').focus().select();
        }
    }

    private hsnSelectionMain(self: this) {
        let selectedRows = self.gridApiHsn.getSelectedRows();
        if (selectedRows.length > 0) {
            this.SelectedHsn.emit(selectedRows[0]);
        }
    }

    invoiceInfo: any;
    hsnSelected(event) {
        let selectedRowHsn = this.gridApiHsn.getSelectedRows();
        if (selectedRowHsn.length > 0) {
            this.selectedHsnInfo = selectedRowHsn[0];
        }
    }

    onCustSelectionChanged(event) {
        this.hsnSelectionMain(this);
    }

    onHsnSelectionChanged(event) {
        this.hsnSelectionMain(this);
    }


    quickSearch(event, id) {
        this.gridApiHsn.setQuickFilter(this.searchValue);
        this.gridApiHsn.onFilterChanged();
        var Rowcount = this.f_check_number(this.gridApiHsn.getDisplayedRowCount());
        if(Rowcount > 0){
            this.gridApiHsn.getModel().getRow(0).setSelected(true);
            // this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
            if (event.which == 13 || event.which == 40) {
                this.gridApiHsn.setFocusedCell(0, "HSN_Code");
            }
        }
    }

    f_check_number(p_value) {
        if (Number(p_value) >= 0) {
            return Number(p_value);
        }
        return 0;
    }
}
